















































import { Component, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { Search } from '@/data/models/search.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import { User, UserStatus, UserType } from '@/data/models/user.model';
import store, { State } from '@/store';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class AssignRiscossione extends Vue {
	@Inject('CrudService') userCrudService!: CrudService<User>;

	userClass: ClassType<User> = User;
	userSearch: Search = new Search('user');
	fattorino: User | null = null;

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.userSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.userSearch.addSimpleFilter('utype', UserType.FATTORINO);
		this.userSearch.addNotEqualFilter('status', UserStatus.INACTIVE);
	}

	submit() {
		this.$emit('submit', this.fattorino);
	}

}
